module.exports = __webpack_public_path__ + "img/nav-right-with-contact-kia-dark02.18f0ed0c.png";